import { I18N } from "./I18N"

export class RejectWaitingOrder {

	_presetReasonKeys = [
		'Current overload',
		'Multiple products unavailable',
		'Shop unexpectedly closed'
	]

	constructor(target, completeTaskAction, taskBtn, extraVariables = {}, printReceipt) {
		this._completeTaskAction = completeTaskAction
		this._taskBtn = taskBtn
		this._extraVariables = extraVariables
		this._printReceipt = printReceipt
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
	}

	close = () => this.setVisible(false)

	setVisible = visible => {
		if (visible) {
			this._target.innerHTML = `
				<div class="modalCanvas">
				<div id="rejectOrderModalShader" class="modalShader"></div>
				<div class="card modal">
					<button id="rejectOrderCloseBtn" class="closeBtn"><span class="material-icons">close</span></button>
					<div class="dlgTopSpacer"><h2 i18n>Reason for rejection</h2></div>
					<div class="btnGroup vertical" id="rejectReasonPresets"></div>
					<div class="dlgTopSpacer">
						<input type="text" id="rejectReasonFreeText" style="width: 100%;">
						<button type="button" id="rejectReasonFreeTextBtn" class="primary" style="margin-top: 0.5rem;" i18n>Confirm</button>
					</div>
				</div>
			`
			const submit = reason => {
				this._completeTaskAction(this._taskBtn, { ...this._extraVariables, rejectionReason: reason }, this._printReceipt)
				this.close()
			}
			const presetsContainer = this._target.querySelector('#rejectReasonPresets')
			this._presetReasonKeys.forEach(reasonKey => {
				const label = I18N.translate(reasonKey)
				const btn = document.createElement('button')
				btn.type = 'button'
				btn.className = 'primary'
				btn.textContent = label
				btn.addEventListener('click', () => submit(label))
				presetsContainer.appendChild(btn)
			})
			const freeTextInput = this._target.querySelector('#rejectReasonFreeText')
			freeTextInput.setAttribute('placeholder', I18N.translate('Other reason (please specify)'))
			this._target.querySelector('#rejectReasonFreeTextBtn').addEventListener('click', () => {
				const freeText = freeTextInput.value.trim()
				if (freeText) {
					submit(freeText)
				}
			})
			this._target.querySelector('#rejectOrderModalShader').addEventListener('click', () => this.close())
			this._target.querySelector('#rejectOrderCloseBtn').addEventListener('click', () => this.close())
			I18N.translateElement(this._target)
			this._target.removeAttribute('hidden')
			window.scrollTo(0, 0)
		}
		else {
			this._target.innerHTML = ''
			this._target.setAttribute('hidden', '')
		}
	}
}
